<template>
    <div class="lg:tw-relative">
        <AcquisitionFormProgress :total-steps="2" :step="1" />
        <Heading :size="2" :title="headline" />
        <TrustpilotRating>
            <p class="tw-font-medium">Kunden vertrauen auf uns.</p>
            <p>Unsere lokalen Experten begeistern mit maßgeschneiderten Traumreisen!</p>
        </TrustpilotRating>
        <info-snippet
            v-if="(country && !country.mainCountry.isTourOperatorGermanSpeaking) || tour && !tour.mainCountry.isTourOperatorGermanSpeaking"
            icon="languageIcon"
            hasBackground
        >
            Unsere Experten {{ countryName ? 'in ' + countryName : '' }} sprechen zwar nur Englisch, kennen ihr Land aber umso besser.
        </info-snippet>
        <time-selector :country-name="country?.title || tour.mainCountry.staticCountry.shortName" />
        <duration-selector />
        <info-snippet icon="MapIcon" hasBackground>
            Deine Angaben helfen unseren lokalen Reiseexperten, Dir einen maßgeschneiderten Reisevorschlag zu erstellen.
        </info-snippet>
        <person-count :country-name="country?.title || tour.mainCountry.staticCountry.shortName" />
        <budget-selector />
        <travel-message-input :country-name="country?.title || tour.mainCountry.staticCountry.shortName" />
        <custom-button
            @click="routeChange()"
            :disabled="!travelData.month || !travelData.year"
        >
            Weiter &rarr;
        </custom-button>
        <testimonials @mounted="initTrustpilot" />
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import CustomButton from "../components/baseComponents/CustomButton.vue";
import DurationSelector from "../components/travelDataComponents/DurationSelector.vue";
import TimeSelector from "../components/travelDataComponents/TimeSelector.vue";
import PersonCount from "../components/travelDataComponents/PersonCount.vue";
import BudgetSelector from "../components/travelDataComponents/BudgetSelector.vue";
import TravelMessageInput from "../components/travelDataComponents/TravelMessageInput.vue";
import InfoSnippet from "../components/travelDataComponents/InfoSnippet.vue";
import Testimonials from "../components/travelDataComponents/Testimonials.vue";
import TrustpilotRating from '../components/travelDataComponents/TrustpilotRating.vue';
import AcquisitionFormProgress from "../components/baseComponents/AcquisitionFormProgress.vue";

export default {
    name: 'TravelData',
    components: {
        AcquisitionFormProgress,
        Testimonials,
        TravelMessageInput,
        BudgetSelector,
        PersonCount,
        TimeSelector,
        DurationSelector,
        CustomButton,
        InfoSnippet,
        TrustpilotRating
    },
    created () {
        // inquiryStart is currently locked on GTM side to only fire when triggered from /de/inq or /de/reise-planen
        this.$gtm.trackEvent({
            event: 'inquiryStart',
            travelType: window.location.pathname.includes('reise-planen') ? 'country' : 'tour',
            country: this.country?.mainCountry.staticCountry.shortName || this.tour.mainCountry.staticCountry.shortName
        })
        if(localStorage.getItem('travelData')) {
            const storedData = JSON.parse(localStorage.getItem('travelData'))
            // Only load the stored data if the current route matches either the
            // stored tour or country.
            if (
                this.tour && storedData.tour === this.tour.uid ||
                this.country && storedData.destinationCountry === this.country.uid
            ) {
                this.$store.commit('tour/setTravelData', storedData);
            }
        }
    },
    mounted() {
        // Initialize TrustPilot widget
        this.initTrustpilot();
        this.$store.commit('tour/setInquiryType', this.country?.mainCountry.inquiryType || this.tour.mainCountry.inquiryType);
    },
    computed: {
        ...mapGetters({
            travelData: 'tour/travelData',
            tour: 'tour/route',
            country: 'tour/country',
            inquiry: 'tour/inquiry',
        }),
        isCountryAcquisition() {
            return document.URL.includes('/reise-planen/');
        },
        countryName() {
            return this.country?.title || this.tour.mainCountry.staticCountry.shortName;
        },
        headline() {
            let headline = ''
            if (this.country) {
                headline = `Plane deine Rundreise nach ${this.country.title} in nur 2 Minuten`
            } else if (this.tour) {
                headline = this.tour.title
            } else {
                headline = 'Plane deine Reise in nur 2 Minuten'
            }
            return headline
        }
    },
    methods: {
        ...mapActions({
            loadTour: 'tour/loadTour',
            loadCountry: 'tour/loadCountry',
        }),
        // Initialize TrustPilot widget with Firefox private browsing detection
        initTrustpilot() {
            try {
                if (window.Trustpilot) {
                    window.Trustpilot.loadFromElement(document.querySelector('.trustpilot-widget'));
                } else {
                    // Check if we might be in Firefox private browsing
                    const isPrivateMode = !window.indexedDB;
                    if (isPrivateMode) {
                        console.log('TrustPilot widget may be blocked by Firefox private browsing mode');
                    }
                }
            } catch (error) {
                console.log('Error initializing TrustPilot widget:', error);
            }
        },
        async routeChange() {
            if(this.tour) {
                await this.$store.commit('tour/setTour', this.tour.uid);
            } else {
                await this.$store.commit('tour/setDestinationCountry', this.country.uid);
            }
            localStorage.setItem('travelData', JSON.stringify(this.travelData));
            localStorage.setItem('inquiry', JSON.stringify(this.inquiry));
            this.$gtm.trackEvent({
                event: 'inquiryStepOne',
                year: this.travelData.year,
                month: this.travelData.fullMonthName,
                duration: this.travelData.duration,
                numPeople: this.travelData.groupSize.adults + this.travelData.groupSize.children + this.travelData.groupSize.infants,
                budget: this.travelData.budget,
                messageLength: this.travelData.message ? this.travelData.message.length : 0,
                country: this.country ? this.country.mainCountry.staticCountry.shortName : this.tour.mainCountry.staticCountry.shortName
            })
            this.$router.push({name: 'userData'});
        }
    }
}

</script>

<style scoped>

</style>